import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import I18n from 'lib/i18n/i18n';
import Experiments from 'lib/experiments';
import Counter from 'components/counter';
import {dollarsWithoutCents, priceWithoutDollar} from 'helpers/ApplicationHelper';
import {updateSubmissionProgressState} from 'actions/submissionProgress';
import ItemChatBot from 'components/chatBot/itemChatBot';
import {itemSaveLog} from 'actions/item';
import Loader from "../loaderAnimated";

class ValidationNeeded extends Component {
    constructor(props) {
        super(props);
        let experiments = new Experiments(props.Experiments);

        this.state = {
            experiments,
            initTimeDestination: 60000,
            initTime: 0,
            initTimeFreq: 20,
            initTimeoutFreq: 20,
            propertyShow: 0,
            progressBar: 0,
            holdProgress: 0,
            item: props.item,
            onCompleteValidation: props.onCompleteValidation,
            progressTimeout: null,
            progressFinished: false,
            isMounted: true,
            showProgress: false,
            isExpMounted: false
        };

        this.initProgressBar = this.initProgressBar.bind(this);
        this.progressBar = this.progressBar.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.showProperties = this.showProperties.bind(this);

        this.counter = null;
        this.counterMin = null;
    }

    componentWillReceiveProps(nextProps){
        this.setState({item: nextProps.item});

        if(nextProps.Experiments){
            this.setState({experiments: new Experiments(nextProps.Experiments)});
        }

        if (nextProps.item.estimation) {
            this.initProgressBar();
            this.counter = <Counter
                target={nextProps.item.estimation.total.high}
                duration={5000}
                transformFunction={priceWithoutDollar}
                onCount={this.progressBar} />;
            this.counterMin = <Counter
                target={nextProps.item.estimation.total.low}
                duration={5000}
                transformFunction={dollarsWithoutCents} />;
        }
        if(nextProps.item.estimation){
            this.setState({holdProgress: this.state.progressBar});
        } else {
            this.setState({
                initTime: (this.state.initTime + 1500)*(this.state.progressBar / 100),
                initTimeDestination: (this.state.initTime + 1500)*(this.state.progressBar / 100) + 1500
            });
        }

    }

    componentDidMount() {
        this.props.updateSubmissionProgressState('estimation calculation');

        this.showProperties();
    }

    componentWillUnmount() {
        this.props.updateSubmissionProgressState();
        clearTimeout(this.state.progressTimeout);
        this.state.isMounted = false;
    }

    componentDidUpdate() {
        if(this.state.progressFinished == false){
            if (this.state.progressBar === 100) {
                this.setState({progressFinished: true});
                this.onComplete();
            }

            if(this.state.item.estimation && !this.state.showProgress || this.state.item.high_value_estimation || this.state.item.under_minimum_estimation || this.state.item.errors){
                this.onComplete();
                this.setState({progressFinished: true});
            }

            if(!!this.state.experiments && !this.state.isExpMounted){
                this.setState({isExpMounted: true});
            }
        }
    }

    initProgressBar() {
        if (!this.state.isMounted) {
            return;
        }
        this.setState({initTime: this.state.initTime + this.state.initTimeFreq});
        let prec = this.state.initTime/this.state.initTimeDestination*100;
        if (prec > 100) {
            prec = 100;
        }
        this.setState({progressBar: prec});
        if (this.state.isMounted) {
            this.setState({
                progressTimeout: setTimeout(()=> {
                    if (this.state.isMounted) this.initProgressBar()
                }, this.state.initTimeoutFreq)
            });
        }
    }

    progressBar(res) {
        if(this.state.progressTimeout){
            clearTimeout(this.state.progressTimeout);
            this.setState({progressTimeout: null});
        }
        let holdProgress = this.state.holdProgress;
        let remainingProgress = 100-holdProgress;
        let prec = holdProgress + (res/this.state.item.estimation.total.high*remainingProgress);

        if (prec > 100) {
            prec = 100;
        }
        this.setState({progressBar: prec});
    }

    onComplete() {
        this.state.onCompleteValidation(this.state.item);
    }

    showProperties(){
        if (!this.state.isMounted) return;
        let propertyShow = this.state.propertyShow;
        if(propertyShow === 6){
            return false;
        }
        propertyShow += 1;
        this.setState({propertyShow});
        setTimeout(this.showProperties, 1000);
    }

    chatBot() {
        return (
            <ItemChatBot />
        );
    }

    render(){
        let counter = this.counter || false;
        let counterMin = this.counterMin || false;

        if(this.props.item.item_type === "watch"){
            return (
                <div id="item-state-estimation-ready">
                    <div className={`item-state-estimation-ready-container`}>
                        {this.state.isExpMounted ? this.chatBot() : null}
                    </div>
                </div>
            );
        }
        else{
            return(<div id="item-state-validation-needed">
                {
                    (
                        ()=>{
                            if(!counter || this.state.experiments == null || !this.state.showProgress){
                                return  <Loader />;
                            }
                            else{
                                return(
                                    <div>
                                        <div className={`estimation-range ${!counter ? 'calculating' : ''}`}>
                                            <div className="estimation-high">
                                                <span className="dollar">$</span>
                                                <span className="price">{counter}</span>
                                            </div>
                                            <div className="estimation-min">
                                                {I18n.getString('itemPage::estimationReady::min')} {counterMin}
                                            </div>
                                            <div className={`calculating ${counter ? 'no-calculating' : ''}`}>{I18n.getString('itemPage::validationNeeded::progressBarTitle')}</div>
                                        </div>
                                        <div className="counter">
                                            <div className="progress">
                                                <div className="progress-bar" style={{width: this.state.progressBar + '%'}}></div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        }
                    )()
                }
            </div>
            );
        }
    }
}

ValidationNeeded.propTypes = {
    item:                   PropTypes.object,
    onCompleteValidation:   PropTypes.func
};

ValidationNeeded.defaultProps = {
    item:                   [],
    onCompleteValidation:   () => {
        return null;
    }
};

const mapStateToProps = (state) => {
    return {
        Experiments: state.Experiments
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({updateSubmissionProgressState, itemSaveLog}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidationNeeded);
